import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import './PrivacyPage.css';

const PrivacyPage = () => {
    const [pageLoaded, setPageLoaded] = useState(false);

    useEffect(() => {
        setTimeout(() => setPageLoaded(true), 100);
    }, []);

    return (
        <div className="privacy-page">
            {/* Banner */}
            <section className={`page-banner ${pageLoaded ? 'banner-loaded' : ''}`}>
                <div className="banner-bg-pattern"></div>
                <div className="container">
                    <h1 className={`banner-title ${pageLoaded ? 'animate-in' : ''}`}>
                        Politique de Confidentialit&eacute;
                    </h1>
                    <p className={`banner-description ${pageLoaded ? 'animate-in' : ''}`}>
                        Protection de vos donn&eacute;es personnelles
                    </p>
                    <nav className={`breadcrumb ${pageLoaded ? 'animate-in' : ''}`}>
                        <Link to="/"><HomeOutlined /> Accueil</Link>
                        <span className="separator">/</span>
                        <span className="current">Politique de confidentialit&eacute;</span>
                    </nav>
                </div>
            </section>

            {/* Content */}
            <section className="privacy-content">
                <div className="container">
                    <p className="privacy-update">Derni&egrave;re mise &agrave; jour : 8 avril 2026</p>

                    <div className="privacy-section">
                        <h2>1. Introduction</h2>
                        <p>
                            TIGOON Connect (ci-apr&egrave;s &laquo; nous &raquo;, &laquo; notre &raquo; ou &laquo; la Soci&eacute;t&eacute; &raquo;)
                            est une plateforme num&eacute;rique de services destin&eacute;e aux chauffeurs VTC, aux livreurs
                            et aux commer&ccedil;ants en C&ocirc;te d'Ivoire.
                            Nous nous engageons &agrave; prot&eacute;ger la vie priv&eacute;e de nos utilisateurs et &agrave; traiter leurs donn&eacute;es personnelles
                            conform&eacute;ment aux lois et r&egrave;glementations en vigueur en C&ocirc;te d'Ivoire, notamment la loi n&deg;2013-450
                            relative &agrave; la protection des donn&eacute;es &agrave; caract&egrave;re personnel.
                        </p>
                        <p>
                            La pr&eacute;sente politique de confidentialit&eacute; d&eacute;crit les types de donn&eacute;es que nous collectons,
                            comment nous les utilisons, les partageons et les prot&eacute;geons lorsque vous utilisez notre application mobile,
                            notre site web (tigoon-connect.com) et nos services associ&eacute;s.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>2. Donn&eacute;es collect&eacute;es</h2>
                        <h3>2.1 Donn&eacute;es fournies par l'utilisateur</h3>
                        <ul>
                            <li><strong>Informations d'identit&eacute; :</strong> nom, pr&eacute;nom, num&eacute;ro de t&eacute;l&eacute;phone, adresse e-mail</li>
                            <li><strong>Informations professionnelles :</strong> num&eacute;ro de permis de conduire, carte grise, informations v&eacute;hicule (marque, mod&egrave;le, immatriculation)</li>
                            <li><strong>Informations de profil :</strong> ville de r&eacute;sidence, photo de profil</li>
                            <li><strong>Informations financi&egrave;res :</strong> historique des transactions, solde de points, transferts</li>
                        </ul>

                        <h3>2.2 Donn&eacute;es collect&eacute;es automatiquement</h3>
                        <ul>
                            <li><strong>Donn&eacute;es d'utilisation :</strong> statistiques de courses, heures de conduite, nombre de trajets</li>
                            <li><strong>Donn&eacute;es techniques :</strong> type d'appareil, syst&egrave;me d'exploitation, identifiant unique de l'appareil</li>
                            <li><strong>Token Firebase (FCM) :</strong> pour l'envoi de notifications push</li>
                        </ul>

                        <h3>2.3 Donn&eacute;es issues de tiers</h3>
                        <ul>
                            <li><strong>Yandex Fleet :</strong> donn&eacute;es de courses, revenus, heures de travail via l'API Yandex</li>
                            <li><strong>Wave :</strong> confirmations de paiement pour le programme &laquo; Ach&egrave;te Ton Terrain &raquo;</li>
                        </ul>
                    </div>

                    <div className="privacy-section">
                        <h2>3. Utilisation des donn&eacute;es</h2>
                        <p>Nous utilisons vos donn&eacute;es personnelles pour :</p>
                        <ul>
                            <li>Cr&eacute;er et g&eacute;rer votre compte chauffeur TIGOON Connect</li>
                            <li>Synchroniser votre profil avec la plateforme Yandex</li>
                            <li>Calculer vos points de fid&eacute;lit&eacute; et bonus (recharges, courses, heures)</li>
                            <li>Traiter les transactions financi&egrave;res (SOS Cr&eacute;dit, transferts entre chauffeurs)</li>
                            <li>G&eacute;rer votre v&eacute;hicule (ajout, liaison, d&eacute;tachement)</li>
                            <li>Administrer les programmes Affili&eacute; et Ambassadeur (commissions, suivi)</li>
                            <li>G&eacute;rer les souscriptions au programme &laquo; Ach&egrave;te Ton Terrain &raquo;</li>
                            <li>&Eacute;tablir les classements mensuels et trimestriels des chauffeurs</li>
                            <li>Vous envoyer des notifications (promotions, mises &agrave; jour, assistance)</li>
                            <li>Am&eacute;liorer nos services et votre exp&eacute;rience utilisateur</li>
                        </ul>
                    </div>

                    <div className="privacy-section">
                        <h2>4. Traitement par OCR</h2>
                        <p>
                            Notre application utilise la reconnaissance optique de caract&egrave;res (OCR) pour extraire les informations
                            de vos documents (permis de conduire recto/verso, carte grise). Ces images sont trait&eacute;es
                            uniquement pour pr&eacute;-remplir les formulaires et ne sont pas stock&eacute;es de mani&egrave;re permanente sur nos serveurs.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>5. Partage des donn&eacute;es</h2>
                        <p>Vos donn&eacute;es personnelles peuvent &ecirc;tre partag&eacute;es avec :</p>
                        <ul>
                            <li><strong>Yandex (Yango) :</strong> notre partenaire officiel de VTC, pour la synchronisation des profils chauffeurs et v&eacute;hicules</li>
                            <li><strong>Wave :</strong> pour le traitement des paiements mobiles</li>
                            <li><strong>Firebase (Google) :</strong> pour l'envoi de notifications push</li>
                            <li><strong>Autorit&eacute;s comp&eacute;tentes :</strong> en cas d'obligation l&eacute;gale</li>
                        </ul>
                        <p>
                            Nous ne vendons jamais vos donn&eacute;es personnelles &agrave; des tiers &agrave; des fins commerciales ou publicitaires.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>6. S&eacute;curit&eacute; des donn&eacute;es</h2>
                        <p>Nous mettons en &oelig;uvre des mesures de s&eacute;curit&eacute; pour prot&eacute;ger vos donn&eacute;es :</p>
                        <ul>
                            <li>Chiffrement des mots de passe (hachage bcrypt)</li>
                            <li>Authentification par jetons JWT avec expiration</li>
                            <li>Contr&ocirc;le d'acc&egrave;s bas&eacute; sur les r&ocirc;les (RBAC)</li>
                            <li>Journalisation des actions administratives (audit log)</li>
                            <li>Base de donn&eacute;es h&eacute;berg&eacute;e sur MongoDB Atlas avec chiffrement au repos</li>
                            <li>Validation des webhooks de paiement par signature partag&eacute;e</li>
                        </ul>
                    </div>

                    <div className="privacy-section">
                        <h2>7. Conservation des donn&eacute;es</h2>
                        <p>
                            Vos donn&eacute;es sont conserv&eacute;es aussi longtemps que votre compte est actif.
                            En cas de suppression de compte, vos donn&eacute;es personnelles seront supprim&eacute;es dans un d&eacute;lai de 30 jours,
                            &agrave; l'exception des donn&eacute;es que nous sommes tenus de conserver pour des raisons l&eacute;gales ou comptables.
                        </p>
                        <p>
                            L'historique des transactions financi&egrave;res est conserv&eacute; pendant une dur&eacute;e de 5 ans
                            conform&eacute;ment aux obligations l&eacute;gales.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>8. Vos droits</h2>
                        <p>Conform&eacute;ment &agrave; la l&eacute;gislation en vigueur, vous disposez des droits suivants :</p>
                        <ul>
                            <li><strong>Droit d'acc&egrave;s :</strong> obtenir une copie de vos donn&eacute;es personnelles</li>
                            <li><strong>Droit de rectification :</strong> corriger vos informations inexactes ou incompl&egrave;tes</li>
                            <li><strong>Droit de suppression :</strong> demander la suppression de vos donn&eacute;es</li>
                            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos donn&eacute;es</li>
                            <li><strong>Droit &agrave; la portabilit&eacute; :</strong> recevoir vos donn&eacute;es dans un format structur&eacute;</li>
                        </ul>
                        <p>
                            Pour exercer ces droits, contactez-nous &agrave; l'adresse : <a href="mailto:support@tigoon.ci">support@tigoon.ci</a>
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>9. Notifications push</h2>
                        <p>
                            Nous utilisons Firebase Cloud Messaging (FCM) pour vous envoyer des notifications relatives &agrave; :
                        </p>
                        <ul>
                            <li>Les mises &agrave; jour de vos demandes d'assistance</li>
                            <li>Les codes OTP pour la v&eacute;rification de votre compte</li>
                            <li>Les promotions et bonus disponibles</li>
                        </ul>
                        <p>
                            Vous pouvez d&eacute;sactiver les notifications &agrave; tout moment depuis les param&egrave;tres de votre t&eacute;l&eacute;phone.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>10. Cookies</h2>
                        <p>
                            Notre site web utilise le stockage local (localStorage) pour conserver votre session de connexion
                            (jeton d'authentification) sur les espaces Affili&eacute;, Ambassadeur et Chauffeur.
                            Aucun cookie tiers de tracking publicitaire n'est utilis&eacute;.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>11. Modifications</h2>
                        <p>
                            Nous nous r&eacute;servons le droit de modifier cette politique de confidentialit&eacute; &agrave; tout moment.
                            Les modifications seront publi&eacute;es sur cette page avec une date de mise &agrave; jour.
                            Nous vous encourageons &agrave; consulter r&eacute;guli&egrave;rement cette page.
                        </p>
                    </div>

                    <div className="privacy-section">
                        <h2>12. Contact</h2>
                        <p>Pour toute question concernant cette politique de confidentialit&eacute;, contactez-nous :</p>
                        <div className="contact-info">
                            <p><strong>TIGOON Connect</strong></p>
                            <p>Bingerville, Abidjan, C&ocirc;te d'Ivoire</p>
                            <p>E-mail : <a href="mailto:support@tigoon.ci">support@tigoon.ci</a></p>
                            <p>T&eacute;l&eacute;phone : +225 27 22 20 81 23</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PrivacyPage;
